<template>
    <footer
        v-qa.hydrated="'hydrated'"
        data-qa="footer"
        class="footer"
    >
        <div class="footer-wrapper">
            <nav class="footer-navigation">
                <FooterMenu
                    v-for="(column, index) in data.columns"
                    :key="index"
                    :data="column"
                />
            </nav>

            <div class="footer-bar">
                <div class="copyright">
                    {{ data.copyright }}
                </div>

                <div class="social">
                    <SocialIcon
                        v-for="(socialNetwork, key) in socialNetworks"
                        :key="key"
                        :data="socialNetwork"
                    />
                </div>

                <div class="payment">
                    <PaymentIcon
                        v-for="(icon, key) in paymentIcons"
                        :key="key"
                        :data="icon"
                    />
                </div>
            </div>
        </div>
        <FooterQANavigationDummy />
    </footer>
</template>

<script setup lang="ts">
import type {
    FooterFragment,
    PaymentIconFragment,
    SocialNetworkFragment,
} from '@/graphql/api'

import FooterMenu from './FooterMenu.vue'
import SocialIcon from './SocialIcon.vue'
import PaymentIcon from './PaymentIcon.vue'
import FooterQANavigationDummy from '@/components/qa/FooterQANavigationDummy.vue'

defineProps<{
    data: FooterFragment
    socialNetworks: SocialNetworkFragment[]
    paymentIcons: PaymentIconFragment[]
}>()
</script>

<style lang="scss" scoped>
.footer {
    width: 100%;
    padding: 0;
    background-color: $stone-3;
    color: $slate;

    .footer-wrapper {
        width: 100%;
        max-width: 768px;
        margin: 0 auto;
        padding: 0 20px 30px;

        @include min-width(1024) {
            max-width: 1440px;
            padding: 50px 20px 30px;
        }
    }

    .footer-navigation {
        display: flex;
        flex-wrap: wrap;
    }

    .footer-bar {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        @include min-width(1024) {
            padding: 0 40px;
            margin: 0 0 40px;
        }

        .copyright {
            width: 100%;
            font-family: $effra-font-stack;
            font-size: 0.75rem;
            font-weight: 350;
            line-height: 1.25rem;
            letter-spacing: 0.05rem;
            text-align: center;
            order: 2;

            @include min-width(1024) {
                width: 33%;
                text-align: left;
                order: initial;
            }
        }

        .social {
            width: 100%;
            display: flex;
            justify-content: center;
            margin: 0 0 30px;

            @include min-width(1024) {
                width: 33%;
                margin: 0;
            }
        }

        .payment {
            width: 100%;
            display: flex;
            justify-content: center;
            margin: 0 0 30px;

            @include min-width(1024) {
                justify-content: flex-end;
                width: 33%;
                margin: 0;
            }
        }
    }
}
</style>
